var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMore = function SvgMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M15 3a3 3 0 1 1-6 0 3 3 0 0 1 6 0m0 9a3 3 0 1 1-6 0 3 3 0 0 1 6 0m0 9a3 3 0 1 1-6 0 3 3 0 0 1 6 0",
    clipRule: "evenodd"
  })));
};
export { SvgMore as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNSAzQzE1IDQuNjU2NzQgMTMuNjU2OSA2IDEyIDZDMTAuMzQzMSA2IDkgNC42NTY3NCA5IDNDOSAxLjM0MzI2IDEwLjM0MzEgMCAxMiAwQzEzLjY1NjkgMCAxNSAxLjM0MzI2IDE1IDNaTTE1IDEyQzE1IDEzLjY1NjcgMTMuNjU2OSAxNSAxMiAxNUMxMC4zNDMxIDE1IDkgMTMuNjU2NyA5IDEyQzkgMTAuMzQzMyAxMC4zNDMxIDkgMTIgOUMxMy42NTY5IDkgMTUgMTAuMzQzMyAxNSAxMlpNMTUgMjFDMTUgMjIuNjU2NyAxMy42NTY5IDI0IDEyIDI0QzEwLjM0MzEgMjQgOSAyMi42NTY3IDkgMjFDOSAxOS4zNDMzIDEwLjM0MzEgMTggMTIgMThDMTMuNjU2OSAxOCAxNSAxOS4zNDMzIDE1IDIxWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";